// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItem_item__SYsjR","dark":"MenuItem_dark__ArOlc","notification":"MenuItem_notification__Cdnj6"};